import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/sonner";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 60_000, refetchOnWindowFocus: false } },
});

const TOAST_OPTIONS = {
  style: {
    background: "#ffffff",
    border: "1px solid #E5E7EB",
    color: "#111",
    boxShadow: "0 6px 20px rgba(16,24,40,0.10)",
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster theme="light" position="top-right" toastOptions={TOAST_OPTIONS} />
    </QueryClientProvider>
  </React.StrictMode>,
);
